<template>
  <div class="pos-refund-container">
    <div class="pos-refund-wrapper">
      <header>{{ $t('swap') }} {{ $tc('ticket', 1) }}</header>
      <button @click="callClose()" class="btn-modal-close">&times;</button>

      <!-- SECTION 1 -->
      <div class="refund-center-content" v-if="section.one && !view">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="input-material mb-4">
            <input v-model="booking_id" id="swapShow" type="text" required="required" placeholder="Ticket No." />
            <label>{{ $tc('ticket', 1) }} {{ $t('no') }}</label>
            <VkeyboardFloat
              :ID="'swapShow'"
              :onClickFun="() => {
                showVKeyboard = !showVKeyboard
              }"
            />
            <Vkeyboard
              :inputName="'swapShow'"
              :showOrHide="showVKeyboard"
              :initialValue="booking_id"
              @onChangeEvent="() => {}"
              @onKeyEnter="show2"
              @changeKeyboardInput="booking_id = $event"
              @onClickClose="() => {
                showVKeyboard = false;
              }"
            />
          </div>

          <button v-on:click="show2()" class="btn-blue-lg">{{ $t('submit') }}</button>
        </div>
      </div>

      <!-- SECTION 2  -->
      <div class="refund-center-content" v-if="(section.two || view) && false">
        <div class="col-lg-8 col-xl-6 mx-auto mb-5">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="input-material">
                <input disabled type="text" :value="booking_id" required="required"  />
                <label>{{ $tc('ticket', 1) }} {{ $t('no') }}</label>
              </div>
            </div>

            <div class="col-6 mb-4">
              <div class="dropdown-curve-container">
                <multiselect
                  v-model="Selectedseats"
                  placeholder="Select Seats"
                  track-by="sl_id"
                  label="sl_seat_name"
                  :options="seats"
                  :multiple="true"
                  disabled
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 mb-4">
              <p>Net Amount: {{ refund.sb_total_net_amount }}&nbsp;{{ refund.curr_code }}</p>
              <p>Gross Amount: {{ refund.sb_total_amount }}&nbsp;{{ refund.curr_code }}</p>
              <p v-if="offer_price && parseInt(offer_price) !== 0">
                Offer Discount: {{ offer_price }}&nbsp;{{
                  refund.curr_code
                }}
              </p>
              <p>Total Amount Paid: {{ refund.sb_total_amount_paid - offer_price }}&nbsp;{{ refund.curr_code }}</p>
            </div>
          </div>
          <div class="row" v-if="!view">
            <div class="col-12 text-center">
              <button class="btn-grey-lg" v-on:click="show1()">{{ $t('cancel') }}</button>
              <button class="btn-blue-lg" v-on:click="show3()">{{ $t('submit') }}</button>
            </div>
          </div>
        </div>
      </div>

      <!-- section 3 -->
      <div class="pos-final-ticket-new mt-5" v-if="section.two || view">
        <div class="row">
          <div
            class="col-3 border-right-dashed border-dark align-items-center text-center pos-ticket-cutter"
          >
            <h5 class="font-weight-bold mb-3">
              Ticket No: {{ bookingDetails.sb_booking_code }}
            </h5>
            <img src="@/assets/img/icons/movie-rolling.svg" class="img-fluid" />
          </div>
          <div class="col-5 pl-5">
            <h5 class="font-weight-bold">
              {{ bookingDetails.movie_name }} ({{ bookingDetails.rating }}) -
              {{ bookingDetails.cinema_address }}
            </h5>
            <div class="text-blue lh-1 mb-2">
              <span class="font-weight-bold mr-2">{{
                bookingDetails.movie_language
              }}</span>
              <b-badge variant="primary">{{ bookingDetails.format }}</b-badge>
            </div>
            <ul class="list-inline" style="font-weight: 500">
              <li class="list-inline-item">
                {{ bookingDetails.t_show_day }}
              </li>
              <li class="list-inline-item">|</li>
              <li class="list-inline-item">
                {{ bookingDetails.ss_start_date_time_full | getMonth }}&nbsp;
                {{ bookingDetails.ss_start_date_time_full | getDayDigit }}
              </li>

              <li class="list-inline-item">|</li>
              <li class="list-inline-item">
                {{ bookingDetails.t_show_time }}
              </li>
            </ul>
            <div>
              <h6 class="text-blue font-weight-bold mb-1">
                {{ bookingDetails.screen_name }}
              </h6>

              <div class="d-flex">
                <img
                  src="@/assets/img/icons/armchair.svg"
                  height="20"
                  width="20"
                  alt
                />
                &nbsp;:
                <ul class="list-inline mb-0 seat-seperated-list ml-2">
                  <li class="list-inline-item">
                    {{
                      bookingDetails.seats_types
                    }}
                  </li>
                  -
                  <li class="list-inline-item">{{ bookingDetails.seat_names }}</li>
                </ul>
              </div>
            </div>
            <div class="mt-2">
              <h6 class="text-blue font-weight-bold mb-1">Ticket Type</h6>

              <div class="d-flex">
                <ul class="list-inline mb-0 seat-seperated-list ml-2">
                  <li class="list-inline-item">
                    {{ AdditionalCharges.ticketType }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-4 align-self-end pr-5 text-right">
            <h6 class="font-weight-bold mb-0">
              Net Amount : {{ currFormat(totalNetAmount) }} {{ refund.curr_code }}
              <br />
                <p
                  class="mb-0"
                  v-for="(charges, chargesIndex) in AdditionalCharges.additionalCharges"
                  :key="chargesIndex"
                >
                  {{ charges.ct_name }} :
                  {{
                    currFormat(charges.tax_value)
                  }}
                </p>
              Gross Amount : {{ currFormat(parseFloat(totalFinalAmount) + parseFloat(offer_price || 0)) }} {{ refund.curr_code }}
              <br />
              Offer Amount : {{ currFormat(offer_price) }} {{ refund.curr_code }}
              <br />
              Total Amount Paid:
              {{
                currFormat(totalFinalAmount)
              }}
              {{ refund.curr_code }}
            </h6>
          </div>
        </div>
      </div>
      <div class="row" v-if="section.two">
            <div class="col-12 text-center">
              <button class="btn-grey-lg" v-on:click="show1()">{{ $t('cancel') }}</button>
              <button class="btn-blue-lg" v-on:click="show3()">{{ $t('submit') }}</button>
            </div>
          </div>
    </div>
    <ManagerAuthLogin :moduleName="'authManager_swap_Audi'" @ManagerDetails="getManagerDetails" :onCheckAuth="onCheckAuthentication" :refId="'authManager_swap_Audi'" />
  </div>
</template>

<script>
import PosCashCalculator from "@/components/Partials/posCashCalculator";
import PosService from "@/services/PosService.js";
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import { min } from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";


export default {
  props: {
    onClickHandler: { type: Function },
    view: {
        type: Boolean,
        default: false
    }
  },
  components: {
    PosCashCalculator,
    Vkeyboard,
    VkeyboardFloat,
    ManagerAuthLogin
  },
  data() {
    return {
      noAuth: false,
      showVKeyboard: false,
      RefundReason: "",
      section: {
        one: true,
        two: false,
        three: false,
      },
      booking_id: "",
      refund: {
        sb_id: null,
        booking_id: null,
        enterRefundAmount: null,
        //
        booking_status_id: null,
        rr_reason: null,
        rr_id: null,
        payment_mode_id: null,
        //
        curr_code: null,
        sb_total_net_amount: null,
        sb_total_amount: null,
        sb_total_amount_paid: null,
        seat_amount_total: 0,
      },
      username: "",
      password: "",
      submitted: false,
      Refunds: [],
      seats: [],
      Selectedseats: [],
      showselectedSeatsArray: [],
      selectedPayment: "",
      offer_name: '',
      offer_price: 0,
      voucher_name: '',
      seatsArray: [],
      AdditionalCharges: [],
      bookingDetails: {
        final_addon_gross_charges: [],
        sb_total_net_amount: 0,
        totalTicketPrice: 0,
      }
    };
  },
  computed: {
    ...mapGetters(["getSwapRefundData", "isSwap", "getswapBookingID", "MANAGER_AUTH_FOR_CHANGES", "ALLOW_CINEMA_SPECIFIC_SWAP_ONLY"]),
    totalFinalAmount() {
      return parseFloat(parseFloat(this.bookingDetails.totalTicketPrice) + parseFloat(this.bookingDetails.total_add_ons_charge)).toFixed(2)
    },
    totalFinalAmount_PAID() {
      return parseFloat(parseFloat(this.bookingDetails.totalTicketPrice) + parseFloat(this.bookingDetails.total_add_ons_charge))
    },
    totalNetAmount() {
      let AddonArray = this.bookingDetails.hasOwnProperty('final_addon_gross_charges') ? this.bookingDetails.final_addon_gross_charges : [];
      let netAmount = this.bookingDetails.sb_total_net_amount || 0;
      if(AddonArray.length > 0) {
        AddonArray.forEach((x) => {
          x.forEach((y) => {
            if(y.is_additional_price_on_ticket == 'Y') {
              netAmount += parseFloat(y.final_price || 0)
            }
          })
        })
      }
      return parseFloat(netAmount || 0).toFixed(2)
    }
  },
  beforeMount() {
      if(this.isSwap) {
          this.booking_id = this.getswapBookingID;
          this.noAuth = true
          this.show2()
      }
  },
  methods: {
    ...mapActions([
      "setSwapRefund",
      "SETSWAPDATA",
      "setSwapBookingID"
    ]),
    validateCinemaSpecificSwap(cinema_id) {
        let status = true;
        let user_cinema_id = this.secureStore.get("USINFO").cinema_id;
        if(this.ALLOW_CINEMA_SPECIFIC_SWAP_ONLY == 'Y') {
          if(cinema_id == user_cinema_id) {
            status = true;
          } else {
            status = false;
          }
        } else {
          status = true;
        }
        return status
      },
     onCheckAuthentication(response) {
      const {valid, name} = response
      if(valid) {
        if(name == "authManager_swap_Audi") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_swap_Audi");
          this.show2();
        }
      } 
    },
    getManagerDetails(user_id) {
      this.$store.commit('SET_MANAGER_AUTH_ID', user_id);
    },
    callClose: function () {
      this.onClickHandler("Swap");
    },
    show1: function () {
      this.section.one = true;
      this.section.two = false;
    },
    show21: function () {
      if (this.booking_id == "") {
        return this.$toasted.show("Enter Booking ID");
      } else {
        let payload = {
          booking_id: this.booking_id,
        };
        PosService.getRefundReason(payload)
          .then((result) => {
            const { data } = result;
            if (data && data.status) {
              this.section.one = false;
              this.section.two = true;
              this.seats = data.Records;
              this.Selectedseats = data.Records.filter((x) => {
                return x.sl_id;
              });
              this.refund = {
                booking_id: this.booking_id,
                ...this.refund,
                ...data.Records[0],
              };
              console.log(" data.Records",  data.Records);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
    show3: function () {
      if (String(this.refund.booking_status_id) === "12") {
        this.$toasted.show("Refund has been done");
      } else if (
        !this.refund.enterRefundAmount ||
        this.refund.enterRefundAmount.length == 0
      ) {
        this.$toasted.show("Please enter refund amount");
      } else if (!this.selectedPayment || this.selectedPayment.length == 0) {
        this.$toasted.show("Please select payment mode");
        return;
      } else {
        let ssb_ids = [];
        let sl_ids = [];
        console.log("this.seats :", this, this.seats);
        console.log("this.Selectedseats :", this.Selectedseats);
        this.Selectedseats.map((y) => {
          this.seats.map((x) => {
            if (x.sl_id == y.sl_id) {
              ssb_ids.push(y.ssb_id);
              sl_ids.push(y.sl_id);
            }
          });
        });
        let payload = {
          ...this.refund,
          ssb_id: ssb_ids,
          sl_id: sl_ids,
          payment_mode_name: this.selectedPayment,
          totalFinalAmount_PAID: this.totalFinalAmount_PAID,
          totalFinalAmount: this.totalFinalAmount,
          totalNetAmount: this.totalNetAmount,
        };
        console.log("payload :", payload);
        this.setSwapRefund(payload);
        this.setSwapBookingID(this.booking_id)
        this.onClickHandler("Swap");
        console.log("getSwapRefundData", this.getSwapRefundData);
      }
    },
    show2: function () {
      this.submitted = true;
      if (this.booking_id == "") {
        return this.$toasted.show("Enter Booking ID");
      }else if(this.MANAGER_AUTH_FOR_CHANGES == 'Y' && !this.noAuth) {
        this.$bvModal.show("authManager_swap_Audi");
      } else {
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            booking_id: this.booking_id,
            username: "",
            password: "",
            noCheck: true
          };
          let loader = this.$loading.show();
          PosService.CheckCinemaManagerLogin(payload).then((response) => {
            const { data } = response;
            loader.hide()
            if (data.status) {
              const {cine_id, cinema_name} = data.bookingDetails
              if(this.validateCinemaSpecificSwap(cine_id)) {
              this.section.one = false;
              this.section.two = true;
              this.seats = data.Records;
              this.Selectedseats = data.Records.filter((x) => {
                return x.sl_id;
              });
              this.bookingDetails = data.bookingDetails;
              this.AdditionalCharges = data.AdditionalCharges;
              let OfferDetails = data.offerDetails;
              this.offer_name = OfferDetails.offer_name;
              this.offer_price = data.bookingDetails.offer_price || parseFloat(data.Records[0].t_offer_price || 0).toFixed(2);
              this.voucher_name = OfferDetails.voucher_name;
              this.refund = {
                booking_id: this.booking_id,
                ...this.refund,
                ...data.Records[0],
              };
               this.refund.enterRefundAmount = parseFloat(this.totalFinalAmount_PAID).toFixed(2)
               this.refund.seat_amount_total = parseFloat(this.totalFinalAmount_PAID).toFixed(2)
               this.selectedPayment = "Cash";
               this.refund.payment_mode_id = 1;
               this.RefundReason = "SWAP";
               this.refund.rr_id = 2;
               } else {
                    this.$toasted.show(`Swap for this Booking can be avail at ${cinema_name} Branch.`);
                  }
            } else {
               this.$store.commit('SET_MANAGER_AUTH_ID', null);
              this.$toasted.show(
                data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      })
    }
    },
  },
};
</script>
<style>
.pos-final-ticket-new {
  height: auto;
  margin: 0 auto;
  padding: 20px 15px;
  border-radius: 5px;
  margin-bottom: 15px;
  width: 975px;
  border: 1px solid #d3d3d3;
  box-shadow: 1px 1px 3px 1px #808080ad;
}

.pos-ticket-cutter::before,
.pos-ticket-cutter::after {
  content: "";
  width: 25px;
  right: -13px;
  height: 25px;
  display: block;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
}
.pos-ticket-cutter::before {
  top: -35px;
  border-bottom: 2px solid #808080ad;
}
.pos-ticket-cutter::after {
  bottom: -35px;
  border-top: 2px solid #808080ad;
}
</style>

 


// WEBPACK FOOTER //
// src/components/Partials/Swap.vue